module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_1357581343097221.bb30428e.jpg";